import { delegate } from "oj-promise-utils";
export const getFocussableElements = (container) => {
    const focusableSelector = "a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex='-1'])";
    return Array.from(container.querySelectorAll(focusableSelector))
        .filter(el => !el.hasAttribute("disabled") && el.tabIndex !== -1 && el.offsetParent !== null);
};
export const trapFocus = (container, targetFocus, currentFocus = document.activeElement, preventScroll = true) => {
    let focusableElements = getFocussableElements(container);
    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];
    targetFocus ??= firstElement;
    targetFocus?.focus({ preventScroll });
    const getNextElement = () => {
        focusableElements = getFocussableElements(container);
        const index = focusableElements.indexOf(document.activeElement);
        return index === -1
            ? firstElement
            : focusableElements[(index + 1) % focusableElements.length];
    };
    const getPreviousElement = () => {
        focusableElements = getFocussableElements(container);
        const index = focusableElements.indexOf(document.activeElement);
        return index === -1
            ? lastElement
            : focusableElements[(index - 1 + focusableElements.length) % focusableElements.length];
    };
    const d = delegate();
    const self = {
        off: () => {
            sub.off();
            currentFocus?.focus({ preventScroll });
            d.resolve();
        },
        promise: d.promise
    };
    const sub = on(container, {
        Tab: e => (e.shiftKey ? getPreviousElement() : getNextElement())?.focus({ preventScroll: false }),
        ArrowDown: e => getNextElement()?.focus({ preventScroll: false }),
        ArrowUp: e => getPreviousElement()?.focus({ preventScroll: false }),
        Escape: e => self.off()
    });
    return self;
};
export const on = (element, handlers, opts) => {
    element.on("keydown.accessibility", (e) => {
        const handler = handlers[e.key];
        if (handler) {
            e.preventDefault();
            handler(e);
        }
    }, opts);
    return {
        off: () => element.off("keydown.accessibility")
    };
};
